import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterByInputString',
    standalone: false
})
export class FilterByInputStringPipe implements PipeTransform {
  public transform<T>(data: T[], filterString: string, property: string): T[] {
    if (data.length === 0 || !filterString) {
      return data;
    }

    return data.filter((item) =>
      item[property].toLowerCase().includes(filterString.toLowerCase())
    );
  }
}
